(() => {
        const profileUrl = 'https://www.trustedshops.de/bewertung/info_X5E3320E759975C0EA51AD5081FDD8D77.html';
        const buyerProtectionUrl = 'https://help.etrusted.com/hc/de/articles/23970864566162-Informationen-zum-Trusted-Shops-G%C3%BCtesiegel-und-zu-den-Trusted-Shops-Bewertungen#das-trusted-shops-g%C3%BCtesiegel';
        const privacyUrl = 'https://www.trustedshops.de/impressum-datenschutz/';
        const spriteUrl = 'https://widgets.trustedshops.com/assets/images/sprite.6b83167aeea54f81c755d67d609fd23a61b5b620.svg';
        let returnFocus = null;
        let exactReviewCount = '4.277';
        let nativeProbeComplete = false;
        let nativeProbeRunning = false;

        const readBadgeData = () => {
          const reviews = document.querySelector('[data-testid="trustbadge-floating-reviews-container"]');
          const scoreMatch = reviews?.innerText.match(/\d+[,.]\d+/);
          const label = reviews?.querySelector('p')?.textContent?.trim() || 'Hervorragend';
          return {
            score: scoreMatch?.[0] || '4,75',
            label
          };
        };

        const findDeep = (root, selector) => {
          if (!root) return null;
          const direct = root.querySelector?.(selector);
          if (direct) return direct;
          if (root.shadowRoot) {
            const shadowMatch = findDeep(root.shadowRoot, selector);
            if (shadowMatch) return shadowMatch;
          }
          const elements = root.querySelectorAll?.('*') || [];
          for (const element of elements) {
            if (!element.shadowRoot) continue;
            const found = findDeep(element.shadowRoot, selector);
            if (found) return found;
          }
          return null;
        };

        const readExactReviewCount = (overlay) => {
          const reviewSection = findDeep(overlay, 'trstd-review-section');
          const source = reviewSection?.shadowRoot?.innerHTML || '';
          const match = source.match(/([\d.]+)\s+verifizierte Bewertungen/i)
            || source.match(/aus\s+([\d.]+)\s+Bewertungen/i);
          return match?.[1] || '';
        };

        const ensureDialog = () => {
          let dialog = document.getElementById('mp-ts-legacy-dialog');
          if (dialog) return dialog;

          dialog = document.createElement('dialog');
          dialog.id = 'mp-ts-legacy-dialog';
          dialog.setAttribute('aria-labelledby', 'mp-ts-dialog-title');
          dialog.innerHTML = `
            <div class="mp-ts-header">
              <strong id="mp-ts-dialog-title">Mini Power</strong>
              <button class="mp-ts-close" type="button" aria-label="Schließen">&times;</button>
            </div>
            <div class="mp-ts-accent"></div>
            <div class="mp-ts-cards">
              <a class="mp-ts-card" href="${profileUrl}" target="_blank" rel="noopener noreferrer">
                <strong class="mp-ts-card-title">Hier kaufst du sicher ein</strong>
                <img class="mp-ts-icon" src="${spriteUrl}#trustmark" alt="">
                <span class="mp-ts-card-copy">Dieser Shop erfüllt die Qualitätskriterien von Trusted Shops</span>
                <span class="mp-ts-arrow" aria-hidden="true"></span>
              </a>
              <a class="mp-ts-card" href="${buyerProtectionUrl}" target="_blank" rel="noopener noreferrer">
                <strong class="mp-ts-card-title">Unabhängiger Käuferschutz</strong>
                <img class="mp-ts-icon" src="${spriteUrl}#shield-simplified" alt="">
                <span class="mp-ts-card-copy">Einkauf bis zu 20.000&nbsp;€ absichern, egal wie du bezahlst.</span>
                <span class="mp-ts-arrow" aria-hidden="true"></span>
              </a>
              <a class="mp-ts-card mp-ts-rating-card" href="${profileUrl}" target="_blank" rel="noopener noreferrer">
                <strong class="mp-ts-card-title">Bewertungsnote: <span data-mp-ts-label>Hervorragend</span></strong>
                <span class="mp-ts-rating-line">
                  <span class="mp-ts-stars" aria-hidden="true">★★★★★<span class="mp-ts-stars-fill">★★★★★</span></span>
                  <strong class="mp-ts-score" data-mp-ts-score>4,75</strong>
                </span>
                <span class="mp-ts-review-count"><strong data-mp-ts-count>4.277</strong> Bewertungen für Mini Power</span>
                <span class="mp-ts-arrow" aria-hidden="true"></span>
              </a>
            </div>
            <div class="mp-ts-footer">
              <span class="mp-ts-ellipsis" aria-hidden="true">...</span>
              <a href="${privacyUrl}" target="_blank" rel="noopener noreferrer">Impressum &amp; Datenschutz</a>
            </div>
          `;
          document.body.append(dialog);
          dialog.querySelector('.mp-ts-close').addEventListener('click', () => dialog.close());
          dialog.addEventListener('close', () => returnFocus?.focus({ preventScroll: true }));
          dialog.addEventListener('click', (event) => {
            if (event.target === dialog) dialog.close();
          });
          return dialog;
        };

        const openDialog = (badge) => {
          const dialog = ensureDialog();
          const data = readBadgeData();
          const scoreNumber = Number.parseFloat(data.score.replace(',', '.'));
          dialog.querySelector('[data-mp-ts-label]').textContent = data.label;
          dialog.querySelector('[data-mp-ts-score]').textContent = data.score;
          dialog.querySelector('[data-mp-ts-count]').textContent = exactReviewCount;
          dialog.querySelector('.mp-ts-stars-fill').style.width = `${Math.max(0, Math.min(100, scoreNumber / 5 * 100))}%`;
          returnFocus = badge;
          if (!dialog.open) dialog.showModal();
          dialog.querySelector('.mp-ts-close').focus({ preventScroll: true });
        };

        const probeNativeOverlay = (badge) => {
          const startedAt = performance.now();
          const check = () => {
            const overlay = document.querySelector('trstd-overlay');
            const exact = readExactReviewCount(overlay);
            if (exact || performance.now() - startedAt >= 1600) {
              if (exact) exactReviewCount = exact;
              overlay?.remove();
              document.body.classList.remove('mp-ts-native-probe');
              nativeProbeComplete = true;
              nativeProbeRunning = false;
              openDialog(badge);
              return;
            }
            window.setTimeout(check, 50);
          };
          window.setTimeout(check, 50);
        };

        document.addEventListener('click', (event) => {
          const target = event.target instanceof Element ? event.target : null;
          const badge = target?.closest('[data-testid="minimized-trustbadge-floating"]');
          if (!badge) return;

          if (!nativeProbeComplete && !nativeProbeRunning) {
            nativeProbeRunning = true;
            returnFocus = badge;
            document.body.classList.add('mp-ts-native-probe');
            openDialog(badge);
            probeNativeOverlay(badge);
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          if (!nativeProbeRunning) openDialog(badge);
        }, true);
      })();
